import { Flex } from '@lego/klik-ui';
import {
  type DetailSectionItem,
  type DetailSectionProps,
  DetailsBox,
} from '@/components/common/details/DetailsBox';
import { FleetBadge } from '@/components/fleet/FleetBadge';
import type { ImageTagDetailResponse } from '@/hooks/repository';
import { CopyableText } from '../common/CopyableText';

type Props = {
  tagDetail: ImageTagDetailResponse;
  workspaceId: number;
};

export const ImageTagDetails = ({ tagDetail, workspaceId }: Props) => {
  const isIndex = tagDetail.children && tagDetail.children.length > 0;

  const items: Record<string, DetailSectionItem> = {
    Tag: { body: tagDetail.tag },
    Digest: {
      body: (
        <CopyableText prefixLength={26} suffixLength={0} value={tagDetail.digest}></CopyableText>
      ),
    },
    'Image Name': { body: tagDetail.imageName },
    Fleets: {
      body:
        tagDetail.fleets.length > 0 ? (
          <Flex flexWrap="wrap" gap={1}>
            {tagDetail.fleets.map((id) => (
              <FleetBadge fleetId={id} key={id} workspaceId={workspaceId} />
            ))}
          </Flex>
        ) : (
          'Unassigned'
        ),
    },
  };

  if (isIndex) {
    items.Type = { body: 'Multi-architecture index' };
  } else {
    items['Scan Status'] = {
      body: tagDetail.scanResults?.scanStatus ?? 'N/A',
    };
    items['Scan Completed At'] = {
      body: tagDetail.scanResults?.imageScanCompletedAt
        ? new Date(tagDetail.scanResults.imageScanCompletedAt).toLocaleString()
        : 'N/A',
    };
  }

  const sections = [{ items }] as DetailSectionProps[];

  return <DetailsBox sections={sections} title={`Tag: ${tagDetail.tag}`} />;
};
